import { DIALOGS } from 'src/models/DialogModel';
import DownloadInvoiceDialog from 'src/components/Dialogs/DownloadInvoiceDialog';
import DownloadPaymentDialog from 'src/components/Dialogs/DownloadPaymentDialog';
import DeleteContactDialog from 'src/components/Dialogs/DeleteContactDialog';
import DeleteCreditCardDialog from 'src/components/Dialogs/DeleteCreditCardDialog';
import DeleteBankAccountDialog from 'src/components/Dialogs/DeleteBankAccountDialog';
import DeleteCustomfieldDialog from 'src/components/Dialogs/DeleteCustomfieldDialog';
import DeletePresetDialog from 'src/components/Dialogs/DeletePresetDialog';
import ConfirmPaymentDialog from 'src/components/Dialogs/ConfirmPaymentDialog';
import DeleteGroupDialog from 'src/components/Dialogs/DeleteGroupDialog';
import CantCancelOnlinePayment from 'src/components/Dialogs/CantCancelOnlinePayment';
import CantRefundOfflinePayment from 'src/components/Dialogs/CantRefundOfflinePayment';
import CantRefundUnpaidPayment from 'src/components/Dialogs/CantRefundUnpaidPayment';
import DeleteTaxDialog from 'src/components/Dialogs/DeleteTaxDialog';
import DeleteProductDialog from 'src/components/Dialogs/DeleteProductDialog';
import DeleteContactRelationDialog from 'src/components/Dialogs/DeleteContactRelationDialog';
import DeleteRelationDialog from 'src/components/Dialogs/DeleteRelationDialog';
import RefundPaymentDialog from 'src/components/Dialogs/RefundPaymentDialog';
import RetryPaymentDialog from 'src/components/Dialogs/RetryPaymentDialog';
import CancelPaymentDialog from 'src/components/Dialogs/CancelPaymentDialog';
import ChangeEmailDialog from 'src/components/Dialogs/ChangeEmailDialog';
import ChangePasswordDialog from 'src/components/Dialogs/ChangePasswordDialog';
import DeleteAccountDialog from 'src/components/Dialogs/DeleteAccountDialog';
import DeleteDepartmentDialog from 'src/components/Dialogs/DeleteDepartmentDialog';
import DeleteProgramDialog from 'src/components/Dialogs/DeleteProgramDialog';
import CancelInvoiceDialog from 'src/components/Dialogs/CancelInvoiceDialog';
import ConfirmLeaveTabDialog from 'src/components/Dialogs/ConfirmLeaveTabDialog';
import LoginDialog from 'src/components/Dialogs/LoginDialog';
import DeleteAdminDialog from 'src/components/Dialogs/DeleteAdminDialog';
import DownloadContactDialog from 'src/components/Dialogs/DownloadContactDialog';
import DownloadAmbassadorDialog from 'src/components/Dialogs/DownloadAmbassadorDialog';
import SendAmbassadorInviteDialog from 'src/components/Dialogs/SendAmbassadorInviteDialog';
import DeleteAmbassadorDialog from 'src/components/Dialogs/DeleteAmbassadorDialog';
import DeleteUserCreditCardDialog from 'src/components/Dialogs/DeleteUserCreditCardDialog';
import ColorPickerDialog from 'src/components/Dialogs/ColorPickerDialog';
import DeleteFundraisingDialog from 'src/components/Dialogs/DeleteFundraisingDialog';
import DownloadTransactionsDialog from 'src/components/Dialogs/DownloadTransactionsDialog';
import UserDownloadReceiptDialog from 'src/components/Dialogs/UserDownloadReceiptDialog';
import ConfirmRemoveLanguageDialog from 'src/components/Dialogs/ConfirmRemoveLanguageDialog';
import EditAmbassadorMessageDialog from 'src/components/Dialogs/EditAmbassadorMessageDialog';
import EditVideoDialog from './EditVideoUrlDialog';
import DialogWrapper from './DialogWrapper';

const DialogContainer = () => (
  <>
    <DialogWrapper dialogKey={DIALOGS.deletePreset} component={DeletePresetDialog} />
    <DialogWrapper
      dialogKey={DIALOGS.cantCancelOnlinePayment}
      component={CantCancelOnlinePayment} />
    <DialogWrapper
      dialogKey={DIALOGS.cantRefundOfflinePayment}
      component={CantRefundOfflinePayment} />
    <DialogWrapper
      dialogKey={DIALOGS.cantRefundUnpaidPayment}
      component={CantRefundUnpaidPayment} />
    <DialogWrapper dialogKey={DIALOGS.deleteContact} component={DeleteContactDialog} />
    <DialogWrapper dialogKey={DIALOGS.deleteGroup} component={DeleteGroupDialog} />
    <DialogWrapper dialogKey={DIALOGS.deleteAccount} component={DeleteAccountDialog} />
    <DialogWrapper dialogKey={DIALOGS.deleteDepartment} component={DeleteDepartmentDialog} />
    <DialogWrapper dialogKey={DIALOGS.deleteProgram} component={DeleteProgramDialog} />
    <DialogWrapper dialogKey={DIALOGS.deleteCustomfield} component={DeleteCustomfieldDialog} />
    <DialogWrapper dialogKey={DIALOGS.deleteCreditCard} component={DeleteCreditCardDialog} />
    <DialogWrapper dialogKey={DIALOGS.deleteBankAccount} component={DeleteBankAccountDialog} />
    <DialogWrapper dialogKey={DIALOGS.invoiceDownload} component={DownloadInvoiceDialog} />
    <DialogWrapper dialogKey={DIALOGS.contactDownload} component={DownloadContactDialog} />
    <DialogWrapper dialogKey={DIALOGS.paymentDownload} component={DownloadPaymentDialog} />
    <DialogWrapper
      dialogKey={DIALOGS.confirmPaymentModalDialog}
      component={ConfirmPaymentDialog} />
    <DialogWrapper dialogKey={DIALOGS.deleteTax} component={DeleteTaxDialog} />
    <DialogWrapper dialogKey={DIALOGS.deleteProduct} component={DeleteProductDialog} />
    <DialogWrapper
      dialogKey={DIALOGS.deleteContactrelation}
      component={DeleteContactRelationDialog} />
    <DialogWrapper dialogKey={DIALOGS.deleteRelation} component={DeleteRelationDialog} />
    <DialogWrapper dialogKey={DIALOGS.refundPayments} component={RefundPaymentDialog} />
    <DialogWrapper dialogKey={DIALOGS.retryPayments} component={RetryPaymentDialog} />
    <DialogWrapper dialogKey={DIALOGS.cancelPayments} component={CancelPaymentDialog} />
    <DialogWrapper dialogKey={DIALOGS.changeEmail} component={ChangeEmailDialog} />
    <DialogWrapper dialogKey={DIALOGS.changePassword} component={ChangePasswordDialog} />
    <DialogWrapper dialogKey={DIALOGS.cancelInvoice} component={CancelInvoiceDialog} />
    <DialogWrapper dialogKey={DIALOGS.leaveTab} component={ConfirmLeaveTabDialog} />
    <DialogWrapper dialogKey={DIALOGS.login} component={LoginDialog} />
    <DialogWrapper dialogKey={DIALOGS.deleteAdmin} component={DeleteAdminDialog} />
    <DialogWrapper
      dialogKey={DIALOGS.deleteUserCreditCard}
      component={DeleteUserCreditCardDialog} />
    <DialogWrapper dialogKey={DIALOGS.ambassadorDownload} component={DownloadAmbassadorDialog} />
    <DialogWrapper
      dialogKey={DIALOGS.sendAmbassadorInvitation}
      component={SendAmbassadorInviteDialog} />
    <DialogWrapper
      dialogKey={DIALOGS.editAmbassadorMessage}
      component={EditAmbassadorMessageDialog} />
    <DialogWrapper dialogKey={DIALOGS.deleteAmbassador} component={DeleteAmbassadorDialog} />
    <DialogWrapper dialogKey={DIALOGS.colorPicker} component={ColorPickerDialog} />
    <DialogWrapper dialogKey={DIALOGS.editVideoUrl} component={EditVideoDialog} />
    <DialogWrapper dialogKey={DIALOGS.deleteFundraising} component={DeleteFundraisingDialog} />
    <DialogWrapper dialogKey={DIALOGS.transactionDownload} component={DownloadTransactionsDialog} />
    <DialogWrapper dialogKey={DIALOGS.userDownloadReceipt} component={UserDownloadReceiptDialog} />
    <DialogWrapper
      dialogKey={DIALOGS.confirmRemoveLanguageDialog}
      component={ConfirmRemoveLanguageDialog} />
  </>
);

export default DialogContainer;
